<template>
  <router-view />
</template>

<script setup>
// App.vue - 根组件
</script>
